import { render, staticRenderFns } from "./apiTestPage.vue?vue&type=template&id=cd3d7ff2&scoped=true"
import script from "./apiTestPage.vue?vue&type=script&lang=js"
export * from "./apiTestPage.vue?vue&type=script&lang=js"
import style0 from "./apiTestPage.vue?vue&type=style&index=0&id=cd3d7ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3d7ff2",
  null
  
)

export default component.exports